import axios from 'axios';

const configuredAxios = axios.create({
  headers: {
    Accept: "application/json"
  }
});

export default configuredAxios;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/ConfiguredAxios.ts